export default __webpack_public_path__ + "static/media/Robert-Team.0d0c366b.png";